    @if (loading) {
        <div class="progress-container">
            <ngb-progressbar [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
        </div>
    }
    @if (showEquityData && equity.close > 0) {
        <div class="col-auto">
            <table class="table table-borderless definitions w-100">
                <tbody>
                    <tr>
                        <td class="text-start" colspan="3">
                            {{ equity.ticker }} ({{ equity.exchangeName.replace('Market - ', '') }})
                        </td>
                    </tr>
                    <tr>
                        <td>Price:</td>
                        <td class="text-end">
                            {{ equity.close | currency: equity.currency: 'symbol' }}
                        </td>
                        <td>
                            @if (delta == 'increase') {
                                <i-bs [name]="iconNames.CaretUpFill" class="d-inline-block" style="color: #0f0"></i-bs>
                            } @else if (delta == 'decrease') {
                                <i-bs [name]="iconNames.CaretDownFill" class="d-inline-block" style="color: #f00"></i-bs>
                            } @else {
                                <span class="d-inline-block" style="width: 16px"></span>
                            }

                        </td>
                    </tr>
                    @if (equity.high) {
                    <tr>
                        <td>High:</td>
                        <td class="text-end">{{ equity.high | currency: equity.currency: 'symbol' }}
                        </td>
                    </tr>
                    }
                    @if (equity.low) {
                    <tr>
                        <td>Low:</td>
                        <td class="text-end">{{ equity.low | currency: equity.currency: 'symbol' }}
                        </td>
                    </tr>
                    }
                    @if (equity.mid && equity.mid > 0) {
                    <tr>
                        <td>Mid:</td>
                        <td class="text-end">{{ equity.mid | currency: equity.currency: 'symbol' }}
                        </td>
                    </tr>
                    }
                    @if (equity.totaltrades) {
                    <tr>
                        <td>Trades:</td>
                        <td class="text-end">{{ equity.totaltrades | number}}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    }
    @if (chartData.series) {
        <div class="col">
            <div echarts [options]="chartData" style="height: 400px;"></div>
        </div>
    }
